import { ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { IDataContentContainer } from "./SectionDataFeed"
import { defaultPosition, ILandingContent, OVERLAY_TYPE, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { OFFLINE_SECTIONS } from "../../landing-edit/landing-edit-overlay/OfflineSections"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { __ } from "src/libs/utilities"
import { MENU_ITEM_ICON_DIVIDER } from "src/libs/basic-view/ExtendMenu"
import { ID } from "src/libs/interfaces/layouts"

export const DataContentPositionContainer = (props: IDataContentContainer) : JSX.Element => {
    
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    if(!props.section) {
        // return <></>
    }
    const data: ILandingContent = props.section.data[ props.i ]
    const position = OFFLINE_SECTIONS.includes(props.section.data[ props.i ].type) ? {} : data.position || {}

    const dtTitle = __( components()[ data.type ].title )
    const getContext = () => {
        if(!isEdit) return 
        const section = props.section
        const _id = props.section.id
        const contentData = props.section.data[ props.i ]
        let context = [
            `${__("Change")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}changeMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`,
            `${__("Transform")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}fullscreen${MENU_ITEM_ICON_DIVIDER}transformMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`, 
            [
                'Change the depth',
                `Arrange to top${MENU_ITEM_ICON_DIVIDER}double-chevron-up`,
                `Move higher${MENU_ITEM_ICON_DIVIDER}chevron-up`,
                `Move below${MENU_ITEM_ICON_DIVIDER}chevron-down`,
                `Arrange to bottom${MENU_ITEM_ICON_DIVIDER}double-chevron-down`,
            ].join(`||`),
            `Add Meat after this${MENU_ITEM_ICON_DIVIDER}plus${MENU_ITEM_ICON_DIVIDER}addMeat${MENU_ITEM_ICON_DIVIDER}${ section.id }.${ contentData.id }`, //
            `${__("Delete")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`, //
        ]
        if( JSON.stringify(position) !== JSON.stringify( defaultPosition() ) ) {
            context.splice(
                2, 
                0, 
                `Reset transform${MENU_ITEM_ICON_DIVIDER}cross${MENU_ITEM_ICON_DIVIDER}resetTransformMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`
            )
        }
        return context.join("|||")
    }

    const onClick = () => {
        if( isEdit ) return
        const modalsOpen: any[] = [ ...useLandingConsoleStore.getState().modalsOpen.filter((_id: ID) => !!_id && data.clickId !== _id), data.clickId ]
        useLandingConsoleStore.setState({ modalsOpen }) 
        // console.log( modalsOpen )
    }
 
    return <div 
        className={`landing-section-data-position ${!!data.clickId ? "pointer" : ""} `} 
        style={{
            transform: `scale(${(position.scale || 1 )}) translateX(${position.left || 0}px) translateY(${position.top || 0}px) rotate(${position.rotate || 0}deg) skew(${position.skewX || 0}deg, ${position.skewY || 0}deg)`,
            width: [SECTION_DESIGN_TYPE.COLUMN ].includes( props.section.designType || SECTION_DESIGN_TYPE.FEED )
                ? 
                "100%"
                :
                OFFLINE_SECTIONS.includes(props.section.data[ props.i ].type) && data.overlayType !== OVERLAY_TYPE.INLINE && isEdit 
                    ? 
                    50 
                    :
                    undefined
        }}
        data-meat-id={ data.id }
        context-title={ getContext() }
        onClick={ onClick }
    > 
        {props.children}
    </div>
}